import { ButtonPrimary, ButtonSize, IconLoader } from '@ui/src';
import RatesForm from '../../../components/settings/details-form/rates-form';
import useRates from './hooks/use-rates';

import cn from '../styles.module.css';

const PspRates = () => {
  const {
    isLoading,
    errorList,
    control,
    errors,
    onSubmit,
    rateSources,
    globalError,
    editIsLoading,
    isDirty,
  } = useRates();

  let content;

  if (isLoading) {
    content = (
      <div className={cn.settingsLoader}>
        <IconLoader />
      </div>
    );
  } else {
    content = (
      <>
        {!errorList && (
          <RatesForm
            control={control}
            errors={errors}
            onSubmit={onSubmit}
            rateSources={rateSources}
          >
            <>
              {globalError && (
                <div className={cn.saveGlobalError}>{globalError}</div>
              )}
              <ButtonPrimary
                text={editIsLoading ? 'Loading...' : 'Save'}
                onClick={onSubmit}
                bold
                size={ButtonSize.MEDIUM}
                disabled={editIsLoading || !isDirty}
                className={cn.saveDetailsButton}
              />
            </>
          </RatesForm>
        )}
        {errorList && (
          <div className={cn.loadingError}>
            <div className={cn.loadingErrorTitle}>Unable to load data</div>
            <div className={cn.loadingErrorText}>{errorList}</div>
          </div>
        )}
      </>
    );
  }

  return content;
};

export default PspRates;
